import React from 'react';
import {
    eventSteps,
    eventType,
    getStatusOpName,
    OP_STATUS
} from "../../../../../util/varibles/constants";
import { IEvent2, IOperation2 } from "../../../../../util/varibles/interface";
import Invoices from '../../../../Operation/Invoices';
import Locations from "../../../../Operation/Locations";
import ApproveControl from "../../_component/ApproveControl";
import Approver from "../../_component/Approver";
import BoxOpInfo from "../../_component/BoxOpInfo";
import OperationTimeline from "../../_component/OperationTimeline";
import Status from "../../_component/Status";
import Header from "../../Header";
import { callEventPopupOpInfo } from '../../PopupOpInfoContext';
import stylesContainer from "../../style.module.scss";

interface IProps {
    isEdit: boolean
    isApprove: boolean
    data: IOperation2<IEvent2>
}

const Event: React.FC<IProps> = (props) => {
    const {
        data,
        isEdit,
        isApprove,
    } = props;
    const { updateNote, changeState } = callEventPopupOpInfo();
    const { operation } = data;

    const { current_process, event_type, status, pois } = operation;
    const statusText = status === OP_STATUS.PROCESSING ? eventSteps[current_process]?.name : getStatusOpName(status);
    const { name = '' } = eventType[event_type] || {}
    console.log(operation.invoices);
    return <>
        <Header operation={operation}>
            <div className={stylesContainer.title}>
                <div className='ml-3 flex align-items-center'>
                    <Status {...{ status, statusText }} />
                    <Locations className='ml-5' locations={pois || []} separate={', '} />
                </div>
            </div>
        </Header>

        <div className={stylesContainer.body}>
            <OperationTimeline data={data} />
        </div>
        <BoxOpInfo data={data} isEdit={isEdit} handleUpdateNote={updateNote}>
            <ApproveControl {...{ isApprove, operation, handleChangeState: changeState }} />
            <Approver operation={operation} />
            <div className="min-h-[28px] flex items-center mb-1">
                <Invoices operation={operation} />
            </div>
            <div className={[stylesContainer['container-box'], 'mb-10 pl-[20px]'].join(' ')}>
                <div className="text-comment pb-[2px]">Event type:</div>
                <div className={[stylesContainer['box-custom'], stylesContainer['event-type']].join(' ')}>{name}</div>
            </div>
        </BoxOpInfo>
    </>;
};

export default Event;
